import { RouteObject } from "react-router";
import { CertificatesRoute } from "@/routes/processes/[processId]/vbs/certificates/certificates-route";
import { CertificateRoute } from "@/routes/processes/[processId]/vbs/certificates/[certificateId]/certificate-route";

export const certificatesRoutes: RouteObject[] = [
  {
    index: true,
    element: <CertificatesRoute />,
  },
  {
    path: ":certificateId",
    element: <CertificateRoute />,
  },
];
